import { fabric } from 'fabric';

export const loadSvgAsync = async (url) => {
  return new Promise((resolve) => {
    fabric.loadSVGFromURL(url, (objects, props) => {
      resolve({ objects, props });
    });
  });
};
